import { isNullOrWhitespaces } from '../../../utils/isNullOrWhitespaces';
import { Contact } from '../interfaces/Contact';
import { ContactDto } from '../interfaces/dtos/ContactUsDto';
import transformPhones from './transformPhones';

export default function transformContact(dto: ContactDto): Contact {
  return {
    address: dto.address.filter((x) => !isNullOrWhitespaces(x)),
    email: dto.email,
    faxes: transformPhones(dto?.faxes),
    name: dto.name.filter((x) => !isNullOrWhitespaces(x)),
    openingHours: dto.openingHours.filter((x) => !isNullOrWhitespaces(x)),
    phones: transformPhones(dto?.phones),
    serviceCenter: dto.serviceCenter,
  };
}
